import { render } from "./scoreModal.vue?vue&type=template&id=d108ce2a&scoped=true"
import script from "./scoreModal.vue?vue&type=script&lang=js"
export * from "./scoreModal.vue?vue&type=script&lang=js"

import "./scoreModal.vue?vue&type=style&index=0&id=d108ce2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d108ce2a"]])

export default __exports__